"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface ClosingCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, ClosingCtaCopy> = {
  en: {
    eyebrow: "Engineering Calculations & Verification",
    heading: "Need Custom Specification Calculations or Verification?",
    lead: "Collaborate directly with our technical team to validate open area percentages, flow parameters, unit mass, or non-standard weave tolerances for your filter design.",
    primaryLabel: "Request a Quote",
    secondaryLabel: "Calculation Guides",
    note: "Formulated with reference to ISO 9044 and ASTM E2016 engineering standards."
  },
  zh: {
    eyebrow: "工程计算与规格核算",
    heading: "需要非标丝网几何计算或工程参数校验？",
    lead: "直接与我们的工业过滤工程技术团队对接，为您的过滤系统核定有效开孔率、流体流速、米重质量及非标编织公差。",
    primaryLabel: "获取报价",
    secondaryLabel: "查看计算公式指南",
    note: "参考 ISO 9044 与 ASTM E2016 工程标准建立算法模型。"
  },
  es: {
    eyebrow: "Cálculos de ingeniería y verificación",
    heading: "¿Necesita cálculos o verificación de especificaciones a medida?",
    lead: "Colabore con nuestro equipo técnico para validar porcentajes de área abierta, parámetros de flujo, peso unitario y tolerancias no estándar.",
    primaryLabel: "Solicitar presupuesto",
    secondaryLabel: "Guías de cálculo",
    note: "Formulado con referencia a las normas de ingeniería ISO 9044 y ASTM E2016."
  },
  de: {
    eyebrow: "Ingenieurberechnungen & Validierung",
    heading: "Benötigen Sie individuelle Spezifikationsberechnungen oder Überprüfungen?",
    lead: "Arbeiten Sie direkt mit unserem Fachteam zusammen, um freie Siebflächen, Strömungsparameter, Flächenmassen und nicht standardisierte Toleranzen zu validieren.",
    primaryLabel: "Angebot anfragen",
    secondaryLabel: "Berechnungsleitfäden",
    note: "Formuliert unter Bezugnahme auf die Ingenieurstandards ISO 9044 und ASTM E2016."
  },
  fr: {
    eyebrow: "Calculs d'ingénierie et vérification",
    heading: "Besoin de calculs de spécifications sur mesure ou de vérification ?",
    lead: "Collaborez directement avec notre équipe technique pour valider pourcentages de vide, paramètres de débit, masse surfacique et tolérances spécifiques.",
    primaryLabel: "Demander un devis",
    secondaryLabel: "Guides de calcul",
    note: "Formulé en référence aux normes d'ingénierie ISO 9044 et ASTM E2016."
  },
  pt: {
    eyebrow: "Cálculos de engenharia e verificação",
    heading: "Necessita de cálculos de especificações sob medida ou validação?",
    lead: "Colabore com nossa equipe técnica para validar porcentagens de área aberta, parâmetros de fluxo, massa unitária e tolerâncias especiais para seu projeto.",
    primaryLabel: "Solicitar orçamento",
    secondaryLabel: "Guias de cálculo",
    note: "Formulado com referência às normas de engenharia ISO 9044 e ASTM E2016."
  }
};
export default function ClosingCta() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="engineeringcalculations-cta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/CalculationGuidesPage"
  }} note={copy.note} />;
}